import { ComponentProps } from 'react'

import { BodyVariant, FontWeight } from '../../../types/types'
import { astraTwMerge } from '../../Utilities/astraTwMerge'

// Default classes for typography variants from the Astra design system
const variantStyles: Record<BodyVariant, string> = {
    /**
     * 1rem 16px
     */
    'body-large': 'text-body-large leading-body-large tracking-body-large',
    /**
     * 0.875rem 14px
     */
    body: 'text-body leading-body tracking-body',
    /**
     * 0.75rem 12px
     */
    'body-small': 'text-body-small leading-body-small tracking-body-small',
    /**
     * 0.625rem 10px
     */
    'body-extra-small': 'text-body-extra-small leading-body-extra-small tracking-body-extra-small',
}

// Font weights from the Astra design system
const fontWeight: Record<FontWeight, string> = {
    regular: 'font-hero-regular',
    medium: 'font-hero-medium',
    strong: 'font-hero-strong',
}

type Props = ComponentProps<'p'> & {
    as?: 'p' | 'span' | 'div'
    variant?: BodyVariant
    weight?: FontWeight
    'data-test'?: string
}

export const AstraParagraph = ({ children, variant = 'body', weight = 'regular', className, as: Comp = 'p', ...props }: Props) => (
    <Comp className={astraTwMerge(`${variantStyles[variant]} ${fontWeight[weight]} text-default`, className)} {...props}>
        {children}
    </Comp>
)
